export default {
  LOGIN_PAGE: "/login",
  REGISTRATION_PAGE: "/registration",
  HOME_PAGE: "/",

  // User
  //

  USER_LIST: "/user/:page",
  USER_CREATE: "/user-create/",
  USER_EDIT: "/user-edit/:id",

  SPENDING_LIST: "/spending/:page",

  BUYER_DEPOSIT: "/bayer-deposit/:page",
  COMPAIGN_REPORT: "/compaign-report/:page",
  COUNTRY_DEPOSIT: "/country-deposit/:page",

  // Team
  //

  TEAM_LIST: "/team/:page",
  TEAM_CREATE: "/team-create/",
  TEAM_EDIT: "/team-edit/:id",
  TEAM_DETAIL: "/team-detail/:id/page/:page",

  // Lead
  //

  LEAD_LIST: "/lead/:page",
  LEAD_UTM: "/lead-utm/:page",
  LEAD_HISTORY: "/lead-history/:page",
  LEAD_DEPOSIT: "/lead-deposit/:page",

  LEAD_FORM: "/lead-form",
  LEAD_JOBS: "/lead-jobs/:page",

  // Client
  //

  CLIENT_LIST: "/client/:page",
  CLIENT_CREATE: "/client-create",
  CLIENT_EDIT: "/client-edit/:id",

  COUNTRY_LIST: "/country/:page",

  // Integration
  //

  INTEGRATION_LIST: "/integration/:page",
  INTEGRATION_CREATE: "/integration-create",
  INTEGRATION_EDIT: "/integration-edit/:id",
  INTEGRATION_HISTORY: "/integration-history/:page",
  INTEGRATION_RESPONSES: "/integration-responses",

  // Log
  //

  LOG: "/log/:page",

  // Static
  //

  STATIC: "/static",
  BAYER_INFO: "/bayer-info",
  TELEGRAM_FILTER: "/telegram-filter",
  TELEGRAM_RECONCILIATION: "/reconciliation",
};
